'use strict';
import {AnalyticsEventType} from './AnalyticsEventType'
import {AnalyticsEventDispatcher} from './AnalyticsEventDispatcher';
import {GlobalBasketAnalytics} from './GlobalBasketAnalytics';


export function AnalyticsHelper(dispatcher = new AnalyticsEventDispatcher()) {
  let errors = [];
  let cache = null;
  let lastNotifiedJlData = "";

  function ensureDataLayer() {
    if (typeof window.jlData === 'undefined') {
      window.jlData = {};
    }

    if (!window.jlData.error) {
      window.jlData.error = {};
    }

    if (!window.jlData.error.message) {
      window.jlData.error.message = "";
    }

    if (!window.jlData.error.messages) {
      window.jlData.error.messages = [];
    }
  }

  function resetErrors() {
    errors = [];
  }

  function addError(errorMessage, ignoreIfAlreadyExists = false) {
    if (ignoreIfAlreadyExists) {
      if (!errors.includes(errorMessage)) {
        errors.push(errorMessage);
      }
    } else {
      errors.push(errorMessage);
    }
  }

  function getErrors() {
    return errors;
  }

  function addRecommendationsPlacement(location, placement) {
    if (typeof window.jlData === 'undefined') {
      window.jlData = {};
    }

    if (!window.jlData.page) {
      window.jlData.page = {};
    }

    if (!window.jlData.page.productPages) {
      window.jlData.page.productPages = {};
    }

    if (!window.jlData.page.productPages.recommendations) {
      window.jlData.page.productPages.recommendations = {};
    }

    if (!window.jlData.page.productPages.recommendations.placements) {
      window.jlData.page.productPages.recommendations.placements = [];
    }

    placement.location = "bottom";
    window.jlData.page.productPages.recommendations.placements.push(placement);
  }

  function errorStateDifferentSinceLastNotify() {
    return lastNotifiedJlData !== JSON.stringify(window.jlData);
  }

  function notify(additionalData = null, eventType = AnalyticsEventType.ANALYTICS_DATA_UPDATE) {
    if (additionalData) {
      dispatcher.dispatchAnalyticsEvent(additionalData, eventType);
    } else {
      if (errorStateDifferentSinceLastNotify()) {
        dispatcher.dispatchAnalyticsEvent(null, eventType);
        lastNotifiedJlData = JSON.stringify(window.jlData);
      }
    }
  }

  function setGlobalAnalyticsError() {
    ensureDataLayer();
    window.jlData.error.message = errors.join("|").toLowerCase();
    window.jlData.error.messages = errors;
  }

  function publish(eventType = AnalyticsEventType.ANALYTICS_DATA_UPDATE) {
    setGlobalAnalyticsError();
    notify(null, eventType);
  }

  function addAndPublish(errorMessage, eventType = AnalyticsEventType.ANALYTICS_DATA_UPDATE) {
    resetErrors();
    addError(errorMessage, true);
    publish(eventType);
  }

  function setMadeToMeasureGlobalAnalyticsError() {
    ensureDataLayer();
    window.jlData.error.message = errors;
    window.jlData.error.messages = errors;
  }

  function madeToMeasurePublish() {
    setMadeToMeasureGlobalAnalyticsError();
    notify();
  }

  function updateAnalyticsFromResponse(response, formData) {
    if (response.analytics !== null) {
      window.jlData = response.analytics;
      GlobalBasketAnalytics.init(); // Updates the global basket analytics which are not currently part of the server response - TODO Make this part of the server response.

      const basket = response.analytics.basket;
      let detail = null;
      const isFeatureIsOn = document.querySelector('.analytics_additional_services');

      if (isFeatureIsOn && basket && basket.product && basket.product.length && basket.update && !!basket.update.commerceId) {
        let product = basket.product.filter(product => {
          return (product.commerceId === basket.update.commerceId) && !!product.error;
        })[0];

        let errorMessage = product ? product.error : null;

        if (!product) {
          product = basket.product.filter(product => {
            if (product.services && !!product.services.length) {
              const service = product.services.filter(service => {
                if (!service.error.length) {
                  errorMessage = service.error;
                }
                return !!service.error.length;
              })[0];

              return !!service;
            }
          })[0];
        }

        if (product) {
          const {
            itemPrice,
            productId,
            qty,
            services,
            sku
          } = product;

          detail = {
            action: 'basketUpdate',
            type: 'error',
            qtyRequested: formData.get('quantity'),
            product: {
              itemPrice,
              productId,
              qty,
              services,
              sku
            },
            error: {
              type: response.analytics.error.type,
              message: errorMessage
            }
          }
        }
      }

      detail && notify(detail);
    }
  }

  function cacheAnalytics() {
    cache = window.jlData
  }

  function updateAnalyticsFromCache() {
    if (cache !== null) {
      window.jlData = cache;
      notify();
      cache = null;
    }
  }

  return {
    notify,
    resetErrors,
    addError,
    publish,
    setMadeToMeasureGlobalAnalyticsError,
    madeToMeasurePublish,
    getErrors,
    addAndPublish,
    updateAnalyticsFromResponse,
    cacheAnalytics,
    updateAnalyticsFromCache,
    addRecommendationsPlacement
  }
}

let defaultAnalytics = new AnalyticsHelper(new AnalyticsEventDispatcher());

export default defaultAnalytics;
